// The import card in the platform agent's panel (D12): before a menu import or a copy runs, while it runs, and how it
// ended. Wording from the Amigo for menus design's copy sheet (Import card, Not live yet, Buttons, Importing, Failed,
// What to try, the 5 reasons, Went live, Import done).
export default {
  title: {
    import: 'Importer le menu depuis {{platform}}',
    copy: 'Copier le menu de {{restaurant}}',
    data: 'Créer le menu lu par Amigo',
  },
  // A menu Amigo read from a file or the chat (QA36): a change card with each dish, before it is created.
  contents: {
    title: 'Créer {{categories}} et {{dishes}}',
    from: {
      file: 'Amigo a lu cela dans votre fichier',
      chat: 'Amigo a lu cela dans notre discussion',
    },
    summary: 'Crée {{categories}} et {{dishes}}. Vérifiez chaque plat avec son prix dans la liste ci-dessous.',
    price: 'Prix',
    tax_category: 'Catégorie de TVA',
    no_price: 'Pas encore de prix',
    default_tax: 'Votre taux standard',
    // Once approved: the import's run, in the words of creating a menu.
    creating: 'Création de {{categories}} et {{dishes}}…',
    done: 'Le menu est créé : {{categories}}, {{dishes}} et {{option_groups}} figurent au menu de {{restaurant}}',
    done_plain: 'Le menu est créé',
  },
  waiting: "En attente d'approbation",
  labels: {
    from: 'De',
    to: 'Vers',
    menu: 'Menu',
    brings_over: 'Reprend',
  },
  from: {
    // "Lieferando · lieferando.de/speisekarte/pizzeria-lupo-koeln"
    platform: '{{platform}} · {{link}}',
    // "Pizzeria Lupo · 12 categories, 140 dishes"
    restaurant: '{{restaurant}} · {{categories}}, {{dishes}}',
    // "The menu Amigo read · 2 categories, 4 dishes" (B19)
    data: "Le menu qu'Amigo a lu · {{categories}}, {{dishes}}",
  },
  to: {
    only_location: '{{name}}, son seul établissement',
    brand_one: 'Menu de la marque {{name}}, son seul établissement',
    brand_other: 'Menu de la marque {{name}}, les {{count}} établissements',
  },
  menu: {
    empty: 'Vide, il deviendra donc le menu',
    adds: "S'ajoute au menu actuel ({{size}}). Les plats du même nom sont mis à jour ; rien n'est supprimé.",
    // The menu's name and size: "Speisekarte: 12 categories, 140 dishes".
    size_named: '{{name}}: {{categories}}, {{dishes}}',
    size: '{{categories}}, {{dishes}}',
  },
  counts: {
    categories_one: '{{count}} catégorie',
    categories_other: '{{count}} catégories',
    dishes_one: '{{count}} plat',
    dishes_other: '{{count}} plats',
    option_groups_one: "{{count}} groupe d'options",
    option_groups_other: "{{count}} groupes d'options",
  },
  // What an import brings over, as one list: "Categories, dishes, prices, option groups, photos, and allergens and
  // nutrition where Lieferando has them". Each item starts lowercase; the list's first letter is capitalised.
  brings_over: {
    everything: 'Tout, tel quel',
    categories: 'catégories',
    dishes: 'plats',
    descriptions: 'descriptions',
    prices: 'prix',
    option_groups: "groupes d'options",
    photos: 'photos',
    where: {
      allergens_nutrition: 'allergènes et valeurs nutritionnelles si {{platform}} les fournit',
      allergens: 'allergènes si {{platform}} les fournit',
      nutrition: 'valeurs nutritionnelles si {{platform}} les fournit',
    },
  },
  not_live:
    "{{restaurant}} n'est pas encore en ligne : les clients peuvent voir le menu via le lien de la boutique, mais ne peuvent pas commander.",
  buttons: {
    import: 'Importer',
    copy: 'Copier',
    cancel: 'Annuler',
  },
  hint: 'Ou répondez ci-dessous pour modifier quelque chose.',
  action_failed: "Cela n'a pas abouti, rien n'a donc changé. Réessayez dans un instant.",
  // Shop's 409 codes when Import is pressed again while the first one runs (QA125).
  refused: {
    already_running: 'Cette importation est déjà en cours. Amigo vous indique ici quand elle est terminée.',
    already_applying:
      "Cette opération est en cours d'application. Patientez un instant jusqu'à ce qu'elle soit terminée.",
  },
  importing: {
    title: {
      import: 'Importation depuis {{platform}}…',
      copy: 'Copie depuis {{restaurant}}…',
    },
    started: 'Démarré {{time}}',
    queued: 'Démarrage…',
    hint: 'Cela peut prendre quelques minutes. Vous pouvez fermer le panneau ou continuer à travailler ; je publierai le résultat ici.',
  },
  done: {
    // What is on the menu now, while the card is the only result ({{categories}} … are `counts`): "The import from
    // Lieferando is done: 12 categories, 140 dishes and 38 option groups are on Pizzeria Lupo's menu".
    title: {
      import:
        "L'importation depuis {{platform}} est terminée : {{categories}}, {{dishes}} et {{option_groups}} figurent au menu de {{restaurant}}",
      copy: 'La copie est terminée : {{categories}}, {{dishes}} et {{option_groups}} figurent au menu',
    },
    // Without counts, or once Amigo's result under the card says them.
    title_plain: {
      import: "L'importation depuis {{platform}} est terminée",
      copy: 'La copie est terminée',
    },
    finished: 'Terminé {{time}}',
    // The page in the sidebar's words: "Open Menu → Manage menus".
    open: 'Ouvrir {{page}}',
  },
  failed: {
    title: {
      import: "Échec de l'importation : {{reason}}",
      copy: 'Échec de la copie : {{reason}}',
    },
    title_plain: {
      import: "Échec de l'importation",
      copy: 'Échec de la copie',
    },
    nothing: {
      import: "Rien n'a été importé.",
      copy: "Rien n'a été copié.",
    },
    what_to_try: 'À essayer :',
    retry: 'Réessayer',
    reasons: {
      listing_not_found: {
        title: 'fiche introuvable',
        text: "{{platform}} n'a aucun restaurant à ce lien. Rien n'a été importé.",
        try: "Ouvrez le lien dans un navigateur pour vérifier qu'il affiche le menu du restaurant, puis renvoyez-le.",
      },
      listing_not_supported: {
        title: 'fiche non prise en charge',
        text: "Il s'agit d'une page de chaîne {{platform}}, et non du menu d'un restaurant, je ne peux donc pas l'importer. Rien n'a été importé.",
        try: 'Envoyez le lien vers la page de menu du restaurant lui-même sur {{platform}}.',
      },
      platform_failed: {
        title: '{{platform}} a échoué',
        text: "{{platform}} n'a pas répondu, rien n'a donc été importé.",
        try: 'Réessayez dans quelques minutes.',
      },
      // A copy from another restaurant that failed on our side: there is no platform to name.
      copy_failed: {
        title: 'la copie a échoué',
        text: "La copie ne s'est pas terminée, rien n'a donc été copié.",
        try: 'Réessayez dans quelques minutes.',
      },
      // {{listing}} and {{currency}} are currencies with their sign: "British pounds (£)", "euros (€)". {{page}} is the
      // sidebar's My info.
      currency_mismatch: {
        title: 'la devise ne correspond pas',
        text: "La fiche est en {{listing}}, mais {{restaurant}} utilise {{currency}}. Rien n'a été importé.",
        try: "Envoyez une fiche en {{currency}}, ou vérifiez d'abord la devise du restaurant dans {{page}}.",
        text_other: "La fiche est dans une autre devise que celle de {{restaurant}}. Rien n'a été importé.",
        try_other: "Envoyez une fiche dans la devise du restaurant, ou vérifiez d'abord sa devise dans {{page}}.",
      },
      link_paused: {
        title: 'lien suspendu',
        text: "Ce lien a échoué 3 fois de suite, les importations depuis celui-ci sont donc suspendues jusqu'à {{time}}. Rien n'a été importé.",
        text_no_until:
          "Ce lien a échoué 3 fois de suite, les importations depuis celui-ci sont donc suspendues pour le moment. Rien n'a été importé.",
        try: "Envoyez un lien d'une autre plateforme, ou copiez le menu d'un autre restaurant.",
      },
    },
  },
  stopped: {
    title: 'Arrêté : {{restaurant}} est passé en ligne',
    nothing: {
      import: "Rien n'a été importé",
      copy: "Rien n'a été copié",
    },
  },
  // The card folded to one line.
  line: {
    cancelled: 'Annulé',
    expired: 'Expiré',
    replaced: 'Remplacé',
  },
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Approuvé.',
    cancelled: 'Annulé.',
    retried: 'Nouvelle tentative effectuée.',
  },
};
